// ------------------------
// Cart Progress
// ------------------------


// function getCartTotal(rule, cart) {
//   if (rule.discount_type === "discounted_price") {
//     return Number(cart.original_total_price || 0);
//   }

//   return Number(cart.total_price || 0);
// }

function getCartTotal(rule, cart) {
  if (rule.discount_type !== "discounted_price") {
    return Number(cart.total_price || 0);
  }

  return (cart.items || []).reduce((total, item) => {
    let discount = rule.discount_value || 0;

    try {
      if (item.properties?._data) {
        const data = JSON.parse(atob(item.properties._data));
        discount = Number(data.__discount ?? discount);
      }
    } catch (e) {
      console.warn("Invalid _data:", item.properties?._data);
    }

    const discountedPrice =
      item.original_price * (1 - discount / 100) * item.quantity;

    return total + discountedPrice;
  }, 0);
}

function maxSaverUpdatePrice(rule = null, cart = null, debug = false) {
  if(!rule) rule = window.maxSaverData?.[0];
  if(!cart) cart = window.cartData;
  document.querySelectorAll(".price__wrapper").forEach((el) => {
    const price = Number(el.getAttribute("data-price"));
    const productId = Number(el.getAttribute("data-product-id"));

    debug && console.group(`🛍️ Product ${productId}`);

    // Default discount
    let discountValue = Number(rule.discount_value);

    debug && console.log("Default Discount:", discountValue);

    // Find highest priority override (lowest priority value)
    let selectedOverride = null;

    for (const override of rule.overrides || []) {
      const matched = override.products.includes(productId);

      debug &&
        console.log("Checking Override:", {
          priority: override.priority,
          discount: override.discount_percent,
          products: override.products,
          matched,
          reason: matched
            ? "✅ Product matched"
            : "❌ Product not found",
        });

      if (!matched) continue;

      if (
        !selectedOverride ||
        override.priority < selectedOverride.priority
      ) {
        selectedOverride = override;
      }
    }

    // Apply override
    if (selectedOverride) {
      discountValue = Number(selectedOverride.discount_percent);

      debug &&
        console.log("✅ Override Applied:", {
          priority: selectedOverride.priority,
          discount: selectedOverride.discount_percent,
          reason: "Lowest priority value has highest priority",
        });
    } else {
      debug &&
        console.log("ℹ️ No override matched. Using default discount.");
    }

    const productData = {
      productId,
      price,
      discountValue,
      discountedPrice: Math.round(
        price - (price * discountValue) / 100
      ),
    };

    debug && console.log("Final Product Data:", productData);

    // Update DOM
    const priceEls = el.querySelectorAll(".max_saver-oprice");

    if (priceEls.length) {
      priceEls.forEach((priceEl) => {
        priceEl.innerHTML = formattedPrice(productData.discountedPrice);
      });

      debug &&
        console.log(
          `✅ Updated ${priceEls.length} .max_saver-oprice element(s) with ${productData.discountedPrice}`
        );
    } else {
      debug &&
        console.warn("❌ .max_saver-oprice element not found.");
    }

    debug && console.groupEnd();
  });
}


window.updateCartProgress = function () {
  const rule = window.maxSaverData?.[0];
  const cart = window.cartData;
  const tglvalue = document.querySelector('.cart-toggle__btn.active')?.getAttribute('data-value');
  const cprogress = document.querySelector(".cart-progress");
  if (!rule || !cart) return;
  const progressFill = document.querySelector(".cart-progress__fill");
  const progressText = document.querySelector(".cart-progress__text");
  if (!progressFill || !progressText) return;
  const threshold = Number(rule.threshold_value) * 100;
  const total = getCartTotal(rule, cart);
  console.log(total,'total>>>>>>>>')
  if (!threshold) {
    progressFill.style.width = "0%";
    progressText.textContent = "";
    return;
  }
  const remaining = Math.max(threshold - total, 0);
  const percent = Math.min((total / threshold) * 100, 100);
  progressFill.style.width = `${percent}%`;
  if(tglvalue == 'max-saver') {
    cprogress.classList.remove('hidden');
     document.body.classList.remove("has_normal-saver");
  } else {
    cprogress.classList.add('hidden');
    document.body.classList.add("has_normal-saver");
  }
  if (remaining <= 0) {
   progressText.innerHTML = progressText.dataset.success;
  } else {
    const formattedRemaining = formattedPrice(remaining);
    progressText.innerHTML = `Add <span class="remaining-price">${formattedRemaining}</span> more to unlock Max Saver`;
  }
};

const formattedPrice = (amount = 0) => {
  try {
    return (window.format_money || "Rs. {{amount}}").replace(
      /{{\s*(amount|amount_no_decimals)\s*}}/g,
      (_, t) =>
        t === "amount"
          ? (Number(amount) / 100).toFixed(2)
          : Math.round(Number(amount) / 100).toString()
    );
  } catch (e) {
    return "Rs. "+(Number(amount) / 100).toFixed(2);
  }
};

// ------------------------
// Collection Loader
// ------------------------

const collectionCache = {};

async function getCollectionProductIds(handle) {
  if (collectionCache[handle]) {
    return collectionCache[handle];
  }

  let page = 1;
  let ids = [];

  try {
    while (true) {
      const response = await fetch(
        `/collections/${handle}?view=ajax&page=${page}`
      );

      if (!response.ok) break;

      const text = (await response.text()).trim();

      if (!text) break;

      const pageIds = text
        .split(",")
        .map(Number)
        .filter(Boolean);

      ids.push(...pageIds);

      if (pageIds.length < 250) break;

      page++;
    }
  } catch (err) {
    console.error(err);
  }

  ids = [...new Set(ids)];
  collectionCache[handle] = ids;

  return ids;
}

let collectionsLoaded = false;

async function loadCollections() {
  console.log({collectionsLoaded}, "<<<calll collectionsLoaded")
  if (collectionsLoaded) return;

  const promises = [];

  window.maxSaverData.forEach((maxSaver) => {
    maxSaver.overrides.forEach((override) => {
      override.products ||= [];

      override.collections.forEach((collection) => {
        promises.push(
          getCollectionProductIds(collection.handle).then((ids) => {
            override.products.push(...ids);
          })
        );
      });
    });
  });

  await Promise.all(promises);

  window.maxSaverData.forEach((maxSaver) => {
    maxSaver.overrides.forEach((override) => {
      override.products = [...new Set(override.products)];
      delete override.collections;
    });
  });

  collectionsLoaded = true;

    
  const rule = window.maxSaverData?.[0];
  const cart = window.cartData;
    if (!rule || !cart) return;
   maxSaverUpdatePrice(rule, cart);

  console.log("Collections Loaded"); 
}
document.addEventListener("DOMContentLoaded", loadCollections);

// ------------------------
// Toggle
// ------------------------

document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".cart-toggle__btn");
  const rule = window.maxSaverData?.[0];
  const cart = window.cartData;
  const total = getCartTotal(rule, cart);
  if (!btn) return;

  document
    .querySelector(".cart-toggle__btn.active")
    ?.classList.remove("active");

  btn.classList.add("active");

  console.log(total,'total<<<<<>>>>')
  if (total > 0) {
    document.body.classList.add("loader");
    setTimeout(function(){ document.body.classList.remove("loader");},2000);
  } else {
    document.body.classList.remove("loader");
  }

  const isMaxSaver = btn.classList.contains("max-saver");

  sessionStorage.toggle
    ? sessionStorage.toggle("maxSaverActive", isMaxSaver)
    : isMaxSaver
      ? sessionStorage.setItem("maxSaverActive", "true")
      : sessionStorage.removeItem("maxSaverActive");

  updatePageData();

  window.updateCartProgress?.();
  setMaxSaver(isMaxSaver);

  if (!isMaxSaver) return;

  await loadCollections();
  if (!rule || !cart) return;

  maxSaverUpdatePrice(rule, cart);
  updateCheckout();



  console.log(
    total >= Number(rule.threshold_value)
      ? "Eligible for Max Saver"
      : "Not Eligible"
  );

});

document.addEventListener("DOMContentLoaded", () => {
  window.updateCartProgress();
  const btn = document.querySelector(".cart-toggle__btn.max-saver");
  const nbtn = document.querySelector(".cart-toggle__btn.normal_max-btn");
  const isMaxSaverActive = sessionStorage.getItem("maxSaverActive") === "true";
  if (isMaxSaverActive && btn) {
    console.log(isMaxSaverActive,'isMaxSaverActive',btn);
    document.querySelectorAll(".gift-modal__cta").forEach((el) => {
      el.disabled = true;
    });
    btn.click();
  } else if (nbtn) {
    nbtn.click();
  }
});

document.addEventListener('cart:maxsaver', () => {
  console.log('Cart maxsaver');
  fetch("/cart.js").then(r=>r.json()).then(c=>{
    window.cartData = c;
    window.updateCartProgress();
    updateCheckout();
    if(c.item_count <= 0 ){
      window.location.reload();
      document.body.classList.remove("loader");
    }
  });
  updatePageData();
});
document.addEventListener('header:unsticky', () => {
  console.log('header unsticky');
  maxSaverSticky(false);
});
document.addEventListener('header:sticky', () => {
  console.log('header sticky');
  maxSaverSticky(true);
});


function maxSaverSticky(flag = false) {
  return;
  const stickyHeader = document.querySelector(".site-header");
  const header = document.querySelector(".header-layout--center-drawer");
  const toggle = document.querySelector(".cart-toggle--wrapper");

  if (!stickyHeader || !header || !toggle) return;

  if (flag) {
    toggle.style.top = `${header.offsetHeight + 20}px`;
    toggle.classList.add("is-sticky", "max-saver--opening");
  } else {
    toggle.style.top = "0px";
    toggle.classList.remove("is-sticky", "max-saver--opening");
  }
}


function updateCheckout(){
  try {
    const thresholdValue = Number( window.maxSaverData?.[0].threshold_value);
    const cartTotal = Number(window.cartData.total_price) / 100;
    const maxSaver = document.querySelector(".max-saver");
    const checkoutBtn = document.querySelector(".cart-mobile-checkout__btn");
      if (checkoutBtn && maxSaver?.classList.contains("active") && cartTotal < thresholdValue){
        console.log('innnnnnnnnn');
        checkoutBtn?.setAttribute("disabled", "disabled");
      }else {
          console.log('ellllllll');
        checkoutBtn?.removeAttribute("disabled");
      }
  } catch (error) {
    console.warn(error);
  }
}


window.getProductDiscount = (productID) => {
  const data = window.maxSaverData?.[0];
  if (!data) {
    console.log("[Discount] No maxSaverData found");
    return null;
  }
  productID = +productID;
  const normalDiscount = +data.discount_value || 0;
  console.log("[Discount] Checking Product:", productID);
  console.log("[Discount] Normal Discount:", normalDiscount);
  const override = data.overrides
    ?.sort((a, b) => b.priority - a.priority)
    .find(({ products, discount_percent, priority }) => {
      const matched = products?.includes(productID);

      if (matched) {
        console.log("[Discount] Override Matched:", {
          priority,
          discount: discount_percent,
        });
      }
      return matched;
    });
  const result = {
    discount: override?.discount_percent ?? normalDiscount,
    normalDiscount,
    overrideDiscount: override?.discount_percent ?? null,
    isOverride: !!override,
  };

  // console.log("[Discount] Final Result:", result);

  return result;
};

const setMaxSaver = (v, reload = false) =>
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        _isMaxSaverEnabled: String(!!v),
      },
    }),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to update cart");
      return res.json();
    })
    .then((cart) => {
      if (reload && location.pathname === "/cart") location.reload();
      typeof refreshImpulseCart === "function" && refreshImpulseCart();
      return cart;
    });

document.addEventListener("cart:build", () => {
  console.log("cart page reloaded");
  const e=Date.now()+3e3,v=setInterval(()=>Date.now()>=e?clearInterval(v):updatePageData(),16);
});

document.addEventListener("collection:reloaded", () => {
  console.log("Collection reloaded");
  updatePageData();
});

document.addEventListener("collection:loadmore", (e) => {
  console.log("Load more completed", e.detail);
  updatePageData();
});


function updatePageData() {
  const path = location.pathname;

  const page =
    path === "/" ? "index" :
    path === "/cart" ? "cart" :
    path.includes("/products/") ? "pdp" :
    path.includes("/collections/") ? "plp" :
    "";

  const isMaxSaver =
    document.querySelector(".cart-toggle__btn.active")?.dataset.value === "max-saver";

  /* ---------- Common (Runs on every page) ---------- */

  document
    .querySelector(".main_banner_wrapper")
    ?.classList.toggle("hidden", isMaxSaver);

  document
    .querySelector(".max_saver_wrapper")
    ?.classList.toggle("hidden", !isMaxSaver);

  document.querySelectorAll(".normal_price").forEach((el) => {
    el.classList.toggle("hidden", isMaxSaver);
  });
  document.querySelectorAll(".custom_offers_container").forEach((el) => {
    el.classList.toggle("hidden", isMaxSaver);
  });
  document.querySelectorAll(".cart-offer-progressbar").forEach((el) => {
    el.classList.toggle("hidden", isMaxSaver);
  });
 
  document.querySelectorAll(".max_saver-price").forEach((el) => {
    el.classList.toggle("hidden", !isMaxSaver);
  });

  document.querySelectorAll(".drawer-subtabs [data-subtab='sweet-deals-new']").forEach((el) => {
    el.classList.toggle("hidden", isMaxSaver);
  });
  
  document.querySelectorAll(".gift-modal__cta").forEach((el) => {
    el.disabled = isMaxSaver;
  });
  
  if (isMaxSaver) removeFreeGiftItems();

  /* ---------- Page Specific ---------- */

  const pageHandlers = {
    cart: {
      maxSaver() {
        document
          .querySelectorAll(
            ".cart-summary__discount-row, .cart-summary__coupon-row, .cart-summary__links, .dynamic-clearance-wrapper"
          )
          .forEach((el) => (el.classList.add("hidden")));
        document
          .querySelectorAll(
            ".coupon_label"
          )
          .forEach((el) => (el.innerHTML = "Max Saver Discount"));
      },

      normal() {
        document
          .querySelectorAll(
            ".cart-summary__discount-row, .cart-summary__coupon-row, .cart-summary__links, .dynamic-clearance-wrapper"
          )
          .forEach((el) => (el.classList.remove("hidden")));
        document
          .querySelectorAll(
            ".coupon_label"
          )
          .forEach((el) => (el.innerHTML = "Coupon Discount"));
      },
    },

    index: {
      maxSaver() {},
      normal() {},
    },

    plp: {
      maxSaver() {
        document
          .querySelectorAll(
            ".max-saver-mode"
          )
          .forEach((el) => (el.classList.remove("hidden")));
        document
          .querySelectorAll(
            ".normal-mode"
          )
          .forEach((el) => (el.classList.add("hidden")));
      },
      normal() {
        document
          .querySelectorAll(
            ".max-saver-mode"
          )
          .forEach((el) => (el.classList.add("hidden")));
        document
          .querySelectorAll(
            ".normal-mode"
          )
          .forEach((el) => (el.classList.remove("hidden")));
      },
    },

    pdp: {
      maxSaver() {
        document
          .querySelectorAll(
            ".custom_offers_container"
          )
          .forEach((el) => (el.classList.add("hidden")));
      },
      normal() {
        document
          .querySelectorAll(
            ".custom_offers_container"
          )
          .forEach((el) => (el.classList.remove("hidden")));
      },
    },
  };

  pageHandlers[page]?.[isMaxSaver ? "maxSaver" : "normal"]?.();
}

let removingGift = false;

function removeFreeGiftItems(cart = window.cartData) {
  if (removingGift) return;
  removingGift = true;

  const updates = Object.fromEntries(
    (cart?.items || [])
      .filter(item => item.properties?.__free_gift)
      .map(item => [item.key, 0])
  );

  if (!Object.keys(updates).length) {
    removingGift = false;
    return;
  }
    document.querySelector(".cart-mobile-checkout__btn").disabled = true;

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates })
  })
    .then(res => {
      if (!res.ok) throw new Error("Failed to remove free gifts");
        // window.location.reload();
      typeof refreshImpulseCart === "function" && refreshImpulseCart();
    })
    .catch(err => {
      console.error(err);
    })
    .finally(() => {
      removingGift = false;
      document.querySelector(".cart-mobile-checkout__btn").disabled = false;
    });
}